import { useCallback, useEffect, useState } from 'react';
import { Reports } from '../../../api/relevant';
import { stores } from '../../../stores';
import useReports from '../../../hooks/useBreakpoint/useReports';

export function usePinReport({ report }: {
	report?: {
		id: string;
		pinnedByUsers?: string[];
	};
}) {
	const { updateReports } = useReports();
	const [pinnedToSidebar, setPinnedToSidebar] = useState(isPinned(report));
	useEffect(() => {
		setPinnedToSidebar(isPinned(report));
	}, [report]);

	const setPinned = useCallback(async (pinned: boolean) => {
		try {
			setPinnedToSidebar(pinned);
			await Reports.call('updatePinnedToSidebar', {
				reportIds: [report?.id],
				pinned,
			});
			updateReports();
		} catch (err) {
			// Revert if it fails
			setPinnedToSidebar(!pinned);
		}
	}, [report?.id, updateReports]);

	return {
		pinned: pinnedToSidebar,
		setPinned,
	};
}

export function isPinned(report) {
	return report?.pinnedByUsers?.includes(stores.identity.userId());
}
